{
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.atlassian-intelligence.no-translate": [
    {
      "type": 0,
      "value": "Atlassian Intelligence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.primary.no-translate": [
    {
      "type": 0,
      "value": "Go to Confluence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.secondary.no-translate": [
    {
      "type": 0,
      "value": "Start with Confluence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.subtitle.no-translate": [
    {
      "type": 0,
      "value": "Jump into Confluence to discover what's possible."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.cta.title.no-translate": [
    {
      "type": 0,
      "value": "Ready to get started?"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.description.no-translate": [
    {
      "type": 0,
      "value": "Prompt Atlassian Intelligence to start brainstorming for you or edit your existing writing. Use content across Confluence as input."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature1.title.no-translate": [
    {
      "type": 0,
      "value": "Generate Content"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.description.no-translate": [
    {
      "type": 0,
      "value": "Utilize specialized agents to accomplish a wide variety of tasks, or create your own for whatever you need done."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature2.title.no-translate": [
    {
      "type": 0,
      "value": "Tasks with Rovo agents"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.description.no-translate": [
    {
      "type": 0,
      "value": "Save time by using summaries and audio briefings to get the context you need."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.feature3.title.no-translate": [
    {
      "type": 0,
      "value": "Get information faster"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.features.title.no-translate": [
    {
      "type": 0,
      "value": "Use Atlassian Intelligence in a number of ways:"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.hero.alt.no-translate": [
    {
      "type": 0,
      "value": "Atlassian Intelligence"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.subtitle.no-translate": [
    {
      "type": 0,
      "value": "Looks like you used "
    },
    {
      "type": 1,
      "value": "featureName"
    },
    {
      "type": 0,
      "value": ". Here are a few more ideas for using Atlassian Intelligence."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome-AI.no-translate": [
    {
      "type": 0,
      "value": "Let's look at "
    },
    {
      "type": 1,
      "value": "atlassianIntelligence"
    },
    {
      "type": 0,
      "value": "."
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.email.welcome.no-translate": [
    {
      "type": 0,
      "value": "Welcome, "
    },
    {
      "type": 1,
      "value": "firstName"
    },
    {
      "type": 0,
      "value": "!"
    }
  ],
  "cc-flywheel-feature-discovery.confluence-ai-tips.message-template.email.subject.no-translate": [
    {
      "type": 0,
      "value": "Get work done with Atlassian Intelligence"
    }
  ]
}